import {
  Lock, Ban, Bell, Users, MapPin,
  HardDrive, Code2, Server, Mail, Radio, Captions, SlidersHorizontal,
} from "lucide-react";

// One-line summary reused in compact surfaces (QR pages, onboarding, etc.)
export const PRIVACY_SUMMARY =
  "We only collect what you choose to share, never sell your data, and keep email + networking optional. Friday Conversations is locally owned and operated by its members — not a third-party social network.";

// Short trust pillars — what we promise about your data.
export const PROMISES = [
  {
    icon: Lock,
    title: "Only what you choose to share",
    text: "Your profile shows exactly what you decide to make visible — nothing more. Hide any field anytime.",
  },
  {
    icon: Ban,
    title: "Never sold, ever",
    text: "We don’t sell, rent, or trade your information. Your data is used only to run this community.",
  },
  {
    icon: Bell,
    title: "Notifications are optional",
    text: "Email and push notifications are opt-in and can be switched off whenever you like.",
  },
  {
    icon: Users,
    title: "Networking is your choice",
    text: "Appear in the member directory only if you want to — turn networking visibility off in one tap.",
  },
  {
    icon: MapPin,
    title: "Locally owned & operated",
    text: "Run by its own members in Spokane — not part of Facebook, LinkedIn, or any third-party social network.",
  },
];

// How the site is built & where the data actually lives.
export const STACK = [
  {
    icon: HardDrive,
    title: "Your data lives on our own storage",
    text: "Files and images are stored on our private Cloudflare R2 storage, under the group’s own account.",
  },
  {
    icon: Code2,
    title: "Built locally by WannaWare",
    text: "The entire site, member portal, and behind-the-scenes tools were custom-built by WannaWare.",
    href: "https://wannaware.com",
    linkLabel: "wannaware.com",
  },
  {
    icon: Server,
    title: "Hosted by Emergent",
    text: "The app runs on Emergent AI hosting services.",
  },
  {
    icon: Mail,
    title: "Email by Resend",
    text: "Transactional emails are sent through Resend, using an account owned by Friday Conversations members.",
  },
  {
    icon: Radio,
    title: "Podcasting on Cloudflare Stream",
    text: "Live video and our podcast broadcasts run on Cloudflare Stream.",
  },
  {
    icon: Captions,
    title: "Transcripts by AssemblyAI",
    text: "Episode transcripts are generated automatically with AssemblyAI.",
  },
  {
    icon: SlidersHorizontal,
    title: "Studio tools built in",
    text: "Our sound mixer, production studio, green rooms, and OBS setup are all built directly into the site’s code.",
  },
];
